/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Createdat1Inputs */

const en__field_createdat1 = /** @type {(inputs: _Field_Createdat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created at`)
};

const de__field_createdat1 = /** @type {(inputs: _Field_Createdat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

/**
* | output |
* | --- |
* | "Created at" |
*
* @param {_Field_Createdat1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_createdat1 = /** @type {((inputs?: _Field_Createdat1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Createdat1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_createdat1(inputs)
	return de__field_createdat1(inputs)
});
export { _field_createdat1 as "_field_createdAt" }